import React from 'react';
import { FocalPoint, TitleSize } from '@vaad1st/component.molecule.hero-banner';
import { ColourOptions, PromoBannerComponent } from '@vaad1st/component.molecule.promo-banner';
import { HeadingElement } from 'src/utils/shared-types';

interface Image {
  alt: string;
  url: string;
  dimensions?: {
    width?: number;
    aspectRation?: string;
    height?: number;
  };
  renditions?: {
    mobile?: string;
    tablet?: string;
    avif?: string;
    webp?: string;
  };
}

interface Button {
  text: string;
  href: string;
}

interface PromoBannerProps {
  partnerImage?: Image;
  desktopImage: Image;
  mobileImage: Image;
  buttons?: Button[];
  textIsRich?: string;
  titleSize?: TitleSize;
  titleElement?: HeadingElement;
  title: string;
  focalPoint?: FocalPoint;
  text: string;
  backgroundColour?: ColourOptions;
  isFullWidth?: boolean;
}

const PromoBanner = (props: PromoBannerProps) => {
  return (
    <PromoBannerComponent
      {...props}
      partnerImage={props.partnerImage ? props.partnerImage : undefined}
      desktopImage={props.desktopImage}
      mobileImage={props.mobileImage}
    />
  );
};

export default PromoBanner;
